// libraries
import type { AnyFSA } from '@makemydeal/dr-browser-utils';
import type { ReduxMiddleware, ReduxNext, ReduxStore } from '@makemydeal/dr-shared-store';
import type { StateTree } from '@makemydeal/dr-dash-types';

// actions
import { dealPulseSlideoutViewed } from '../actions/baseDealActionCreators';

// consts/enums
import { SHOW_CUSTOMER_INSIGHTS_SLIDEOUT } from '../actionTypes/baseDealActionTypes';
import {
    TRADE_IN_INTELLIGENCE_EVENT_RECEIVED,
    TRADE_IN_INTELLIGENCE_SETTLED_EMPTY
} from '../actionTypes/tradeInIntelligenceActionTypes';

// selectors
import * as baseDealSelectors from '../selectors/BaseDealSelectors';
import * as consumerInsightsSelectors from '../selectors/consumerInsightsSelectors';
import { getPrimaryScopeState } from '../selectors/primaryScopeSelectors';
import * as tradeInIntelligenceSelectors from '../selectors/tradeInIntelligenceSelectors';
import * as vehicleSelectors from '../selectors/vehicleSelectors';

let isViewOutstanding = false;

export function __resetDealPulseSlideoutState(): void {
    isViewOutstanding = false;
}

const emitSlideoutViewed = (store: ReduxStore<StateTree>) => {
    isViewOutstanding = false;
    const primaryState = getPrimaryScopeState(store.getState());
    store.dispatch(
        dealPulseSlideoutViewed(
            vehicleSelectors.getVehicleAnalyticsPayload(primaryState),
            consumerInsightsSelectors.getConsumerInsights(primaryState),
            tradeInIntelligenceSelectors.getTradeInIntelligenceAnalyticsRecord(primaryState)
        )
    );
};

export const middleware: ReduxMiddleware<StateTree> = (store: ReduxStore<StateTree>) => (next: ReduxNext) => (action: AnyFSA) => {
    const wasOpen =
        action.type === SHOW_CUSTOMER_INSIGHTS_SLIDEOUT &&
        Boolean(baseDealSelectors.getCustomerInsightsSlideoutStatus(store.getState()));

    next(action);

    switch (action.type) {
        case SHOW_CUSTOMER_INSIGHTS_SLIDEOUT: {
            const isOpen = Boolean(action.payload?.showCustomerInsightsSlideout);

            if (isOpen && !wasOpen) {
                if (tradeInIntelligenceSelectors.getIsTradeInIntelligencePending(store.getState())) {
                    isViewOutstanding = true;
                } else {
                    emitSlideoutViewed(store);
                }
            } else if (!isOpen && isViewOutstanding) {
                emitSlideoutViewed(store);
            }
            break;
        }

        case TRADE_IN_INTELLIGENCE_EVENT_RECEIVED:
        case TRADE_IN_INTELLIGENCE_SETTLED_EMPTY: {
            if (isViewOutstanding && !tradeInIntelligenceSelectors.getIsTradeInIntelligencePending(store.getState())) {
                emitSlideoutViewed(store);
            }
            break;
        }

        default:
            break;
    }
};
